import {useState} from 'react';

export const useForm = initVal => {
    const [values, setValues] = useState(initVal);

    return [
        values,
        e => {
            if(e.target){
                setValues({
                    ...values,
                    [e.target.name]:(e.target.type === 'checkbox') ? e.target.checked : e.target.value
                })
            }
            else{
                const keys = Object.keys(e);
                const tempObj = {};
                keys.forEach(function(key){
                    tempObj[key] = e[key];
                });
                
                setValues({
                    ...values,
                    ...tempObj
                })
            }
        }
    ]
}